import { useSelected, useFocused } from 'slate-react';
import type { RenderElementPropsFor } from '../../../../types';
import type { MentionElement } from '../../types';
import MentionBase from '../mention-base';
import { useEditorContext } from '../../../../scripts/context';

export type MentionElementProps = RenderElementPropsFor<MentionElement>;

export default function MentionElementComponent({
  attributes,
  element: { user },
}: MentionElementProps) {
  const selected = useSelected();
  const focused = useFocused();
  const { mention: { element: { onClick } = {} } = {} } = useEditorContext();

  return (
    <MentionBase
      selected={selected && focused}
      user={user}
      onClick={onClick}
      {...attributes}
    ></MentionBase>
  );
}
